import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

interface AppLayoutProps {
    children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const [showSidebar, setShowSidebar] = useState(true);

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    return (
        <div className="d-flex flex-column vh-100">
            <Header />

            <div className="flex-grow-1 d-flex" style={{ overflow: 'hidden' }}>
                {/* Sidebar */}
                <div
                 className="h-100 overflow-auto"
                    style={{
                        width: showSidebar ? '320px' : '60px',
                        minWidth: showSidebar ? '320px' : '60px',
                        transition: 'width 0.3s, min-width 0.3s'
                    }}
                >
                    <Sidebar
                        isExpanded={showSidebar}
                        toggleSidebar={toggleSidebar}
                    />
                </div>

                {/* Main content */}
                <div className="flex-grow-1 p-3" style={{ overflow: 'auto' }}>
                    {children}
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default AppLayout;